import React, { useState } from 'react';
import { Nav, Image } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase'; // ✅ make sure this path is correct

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate(); // ✅ for redirect after logout

  // Track collapsed state of section groups
  const [fraudOpen, setFraudOpen] = useState(
    location.pathname.startsWith('/fraud')
  );

  const isActive = (path) => location.pathname === path;
  const isFraudSection = location.pathname.startsWith('/fraud');

  const handleLogout = async () => {
    try {
      await signOut(auth); // 🔐 Firebase sign out
      navigate('/signin'); // 🚪 Redirect to sign in
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  return (
    <div
      id="sidebar"
      className="sidebar d-flex flex-column justify-content-between sticky-top overflow-auto scroll-box"
      style={{ maxHeight: '100vh', top: 0 }}
    >
      {/* Top: Logo */}
      <div className="text-center logo-img-header p-3">
        <Image src={logo} alt="Logo" fluid />
      </div>

      {/* Middle: Menu */}
      <Nav className="flex-column py-2 menu">
        <Nav.Link
          as={Link}
          to="/dashboard"
          className={`body-text-one ${isActive('/dashboard') ? 'active' : ''}`}
        >
          Dashboard
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/transactions"
          className={`body-text-one ${isActive('/transactions') ? 'active' : ''}`}
        >
          Transactions
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/users"
          className={`body-text-one ${isActive('/users') ? 'active' : ''}`}
        >
          Users
        </Nav.Link>

        <Nav.Link
          as={Link}
          to="/countries"
          className={`body-text-one ${isActive('/countries') ? 'active' : ''}`}
        >
          Countries
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/currencies"
          className={`body-text-one ${isActive('/currencies') ? 'active' : ''}`}
        >
          Currencies
        </Nav.Link>
        <Nav.Link
          as={Link}
          to="/price_config"
          className={`body-text-one ${isActive('/price_config') ? 'active' : ''}`}
        >
          Price Config
        </Nav.Link>
        
        {/* <Nav.Link
          as={Link}
          to="/operators"
          className={`body-text-one ${isActive('/operators') ? 'active' : ''}`}
        >
          Operators
        </Nav.Link> */}
        <Nav.Link
          as={Link}
          to="/packages"
          className={`body-text-one ${isActive('/packages') ? 'active' : ''}`}
        >
          Packages
        </Nav.Link>

        {/* <Nav.Link
          as={Link}
          to="/global_exchange"
          className={`body-text-one ${isActive('/global_exchange') ? 'active' : ''}`}
        >
          Global Exchange
        </Nav.Link> */}

        {/* ── Fraud Management Section ─────────────────────── */}
        <div style={{ marginTop: 8, marginBottom: 2 }}>
          {/* Section header — clickable to collapse/expand */}
          <div
            onClick={() => setFraudOpen((o) => !o)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '6px 25px',
              cursor: 'pointer',
              userSelect: 'none',
              borderLeft: `3px solid ${isFraudSection ? 'var(--accent-lime)' : 'transparent'}`,
              borderRadius: '0 50px 50px 0',
              background: isFraudSection ? 'rgba(217,255,31,0.06)' : 'transparent',
              transition: 'all 0.2s ease',
            }}
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: 1,
                color: isFraudSection ? 'var(--accent-lime)' : 'var(--text-secondary)',
                fontFamily: '"Noto Sans", sans-serif',
              }}
            >
              Fraud Management
            </span>
            <span
              style={{
                fontSize: 10,
                color: 'var(--text-secondary)',
                transform: fraudOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
                display: 'inline-block',
              }}
            >
              ▾
            </span>
          </div>

          {/* Child links — visible when section is open */}
          {fraudOpen && (
            <div style={{ paddingLeft: 12 }}>
              <Nav.Link
                as={Link}
                to="/fraud/dashboard"
                id="nav-fraud-dashboard"
                className={`body-text-one ${isActive('/fraud/dashboard') ? 'active' : ''}`}
                style={{ fontSize: 14 }}
              >
                Dashboard
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/fraud/logs"
                id="nav-fraud-logs"
                className={`body-text-one ${isActive('/fraud/logs') ? 'active' : ''}`}
                style={{ fontSize: 14 }}
              >
                Fraud Logs
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/fraud/blacklist"
                id="nav-fraud-blacklist"
                className={`body-text-one ${isActive('/fraud/blacklist') ? 'active' : ''}`}
                style={{ fontSize: 14 }}
              >
                Blacklist
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/fraud/rules"
                id="nav-fraud-rules"
                className={`body-text-one ${isActive('/fraud/rules') ? 'active' : ''}`}
                style={{ fontSize: 14 }}
              >
                Fraud Rules
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/fraud/suspended"
                id="nav-fraud-suspended"
                className={`body-text-one ${isActive('/fraud/suspended') ? 'active' : ''}`}
                style={{ fontSize: 14 }}
              >
                Suspended Users
              </Nav.Link>
            </div>
          )}
        </div>

        <Nav.Link
          as={Link}
          to="/sliders"
          id="nav-sliders"
          className={`body-text-one ${isActive('/sliders') ? 'active' : ''}`}
        >
          Sliders
        </Nav.Link>

        <Nav.Link
          as={Link}
          to="/settings"
          className={`body-text-one ${isActive('/settings') ? 'active' : ''}`}
        >
          Settings
        </Nav.Link>
      </Nav>

      {/* Bottom: Sign Out */}
      {/* <div className="text-center">
        <Button
          className="btn-logout w-100 rounded-3 py-2 text-white mb-4"
          onClick={handleLogout}
        >
          Sign Out
        </Button>
      </div> */}
      <div className="text-center mb-4"></div>
    </div>
  );
};

export default Sidebar;